export const SAGA_STATE_NAME = 'ReportApprovalSaga';

export class MassApproveReports {
  static type = `[${SAGA_STATE_NAME}] MassApproveReports`;
  constructor(
    public reportIds: string[],
    public sagaId: string
  ) {}
}

export class CheckReportsSagaApprovalState {
  static type = `[${SAGA_STATE_NAME}] CheckReportsSagaApprovalState`;
  constructor(public sagaId: string) {}
}

export class ConfirmReportApproval {
  static type = `[${SAGA_STATE_NAME}] ConfirmReportApproval`;
  constructor(public sagaId: string) {}
}
